const NARVAR_ROLE_PREFIX = 'NARVAR_';

/*
 * Narvar staff rather than a retailer's own user (CPMT-5481). Support-mode
 * sessions carry the retailer's role instead of a NARVAR_* one, so
 * customerSupportLogin has to be checked separately or CSMs get locked out
 * alongside merchants.
 */
export default user => {
  if (!user) return false;

  const { customerSupportLogin, rolesList = [] } = user;

  return (
    Boolean(customerSupportLogin) ||
    rolesList.some(role => role.name.startsWith(NARVAR_ROLE_PREFIX))
  );
};
